/* @flow */
/* eslint-env es6, browser */

import { isValid } from '../utils/coreutils';
import { isCCPAOptedOut } from '../utils/ccpautils';
import pubcommonid from './pubcommonid';
import liverampidp from './liverampidp';
import { isDNT } from '../utils/browserutil';

/**
 * @description Implements manager class for UserIDs
 * @class
 * @exports idm
 */
class _idpmanager {
  _doc: Document;

  _win: window;

  _enabledIDs: Array<string>;

  _IDProviders: Array<IDPInterface>;

  constructor() {
    this._doc = document;
    this._win = window;
    this._enabledIDs = [];
    this._IDProviders = [pubcommonid, liverampidp];
  }

  /**
   * Initialize the object
   *
   * @param {window} w - window object
   * @param {Document} d - document object
   * @param {module:globalParams.globalParams} g - global param object
   * @returns {undefined}
   */
  init(w: window, d: Document, g: globalParam) {
    this._doc = d;
    this._win = w;
    // init all children
    this._IDProviders.forEach(idp => idp.init(w, d, g));
  }

  updateConfig(o: userIDsConfig) {
    this._enabledIDs = o.ids || [];
    // update config for all children
    this._IDProviders.forEach(idp => idp.updateConfig(o[idp.getName()]));
  }

  getUserID(idpName: string = '') {
    const ret = '';
    // do not return ID for CCPA opted out user
    // do not generate/return ID if DNT is enabled
    // do not return if the IDProvider is not enabled
    if (
      !idpName.length ||
      !this._enabledIDs.includes(idpName) ||
      isCCPAOptedOut() ||
      isDNT()
    ) {
      return ret;
    }
    const idp = this._IDProviders.find(v => v.getName() === idpName);
    if (!isValid(idp)) {
      return ret;
    }
    // $FlowFixMe
    return idp.getID();
  }
}

// export singleton object as default for this module
export default new _idpmanager();
